<script lang="ts">
    import Footer from "../../footer/Footer.svelte";
    import Navbar from "../../header/Navbar.svelte";
    import SettingsMenu from "./SettingsMenu.svelte";
    import { appManager } from "../../AppManagerStore";
    import SettingsHeader from "./SettingsHeader.svelte";
    import BasicSettings from "./BasicSettings.svelte";
    import OrganizationsSettings from "./OrganizationsSettings.svelte";
    import type { UserData } from "@anyways-open/identity-api-client";
    import { onMount } from "svelte";
    import { _, locale } from "svelte-i18n";
    import UpdatePassword from "./UpdatePassword.svelte";

    let data: UserData;

    export let view: "general" | "organizations" = "general";

    onMount(async () => {
        data = await $appManager.IdentityApi.getCurrentUser();
    });
</script>

<Navbar isFluid={false} functional={true} />

<SettingsHeader />

<main class="pb-8 pb-md-11 mt-md-n6">
    <div class="container-md">
        <div class="row">
            <SettingsMenu active={view} />

            {#if typeof data !== "undefined"}
                <div class="col-12 col-md-9">
                    {#if view === "general"}
                        <BasicSettings {data} />
                        <UpdatePassword {data} />
                    {/if}
                    {#if view === "organizations"}
                        <OrganizationsSettings {data} />
                    {/if}

                    <!-- <p class="text-center mb-0">
                    <small class="text-muted"
                        >{$_("users.settings.delete.part1")} <a
                            class="text-danger"
                            href="#!">delete your account</a
                        >.</small>
                </p> -->
                </div>
            {/if}
        </div>
    </div>
</main>

<Footer />
